import NiceModal from '@ebay/nice-modal-react';
import React, { Suspense } from 'react';

import { MODALS } from '@/shared/config/modals';

const SettingsModalLazy = React.lazy(() =>
  import('./SettingsModal').then((m) => ({ default: m.SettingsModal })),
);

NiceModal.register(
  MODALS.SETTINGS,
  NiceModal.create(() => (
    <Suspense fallback={null}>
      <SettingsModalLazy />
    </Suspense>
  )),
);
